import { useEffect, useState } from 'react';

import Container from '../../components/Layout/Container';
import PageTopBanner from '../../components/PageTopBanner';

import { TabsLink } from '../../components/Tab/Tabs';
import { introduceTabData } from '../../components/Tab/TabData';
import { fetchGet } from '../../hooks/fetch';
import Loading from '../Loading';

export default function Organization() {
	const pageName = '조직도';
	
	const [isLoading, setIsLoading] = useState(true);
	const [activeTab, setActiveTab] = useState('');
	const [post, setPost] = useState({});
	
	const handleDataFromChild = (data) => {
		setActiveTab(data);
	};
	
	function getPage() {
		fetchGet(
			`/introduction/basic?type=ORGANIZATION&language=`,
			(json) => {
				setPost(json.response);
				setIsLoading(false);
			}
		)
	}

	useEffect(() => {
		setIsLoading(true);
		getPage();
	}, []);

	return (
		<main id="introduce-page-wrap">
			<h1 className="sr-only">{`${pageName} 페이지`}</h1>

			<PageTopBanner />

			<Container>
				<TabsLink
					className="sub-page-tab-con"
					tabsData={introduceTabData}
					activatedTab={activeTab}
					onTabChange={handleDataFromChild}
				/>

				<div className="page-content">
					<div className="content-top">
						<div>
							<h1 className="title">{pageName}</h1>
						</div>
					</div>

					<div>
						{isLoading ? <Loading />
									: <div dangerouslySetInnerHTML={{ __html: post?.content }}/>}
					</div>
				</div>
			</Container>
		</main>
	);
}
